import React from 'react';
// Icons
import { IoIosCloseCircleOutline } from 'react-icons/io';

function ContactFormItem({ form, handleDelete }) {
  return (
    <article
      className='grid bg-colour5 relative shadow-cardShadowBold rounded px-4 py-2 lg:px-16 lg:py-8 mb-6'
      aria-label={`Contact form submission from ${form.firstName} ${form.lastName}`}
    >
      {/* Delete Button */}
      <section className='flex absolute justify-end items-start top-4 right-4'>
        <button
          onClick={() => handleDelete(form.id)}
          className='text-red-600 hover:text-red-800'
          title={`Delete submission from ${form.firstName} ${form.lastName}`}
          aria-label={`Delete contact form from ${form.firstName} ${form.lastName}`}
        >
          <IoIosCloseCircleOutline size={35} />
        </button>
      </section>
      {/* Content Section */}
      
      <section
        aria-labelledby={`contact-heading-${form.id}`}
        className='grid gap-y-4'
      >
        <h4 id={`contact-heading-${form.id}`} className='sr-only'>
          Contact Form Submission Details
        </h4>

        {/* Name */}
        <div>
          <strong className='text-xl font-medium'>Name:</strong>{' '}
          {form.firstName} {form.lastName}
        </div>

        {/* Email */}
        <div>
          <strong className='text-xl font-medium'>Email:</strong>{' '}
          <a href={`mailto:${form.email}`} className='text-colour3'>
            {form.email}
          </a>
        </div>

        {/* Phone */}
        <div>
          <strong className='text-xl font-medium'>Phone:</strong>{' '}
          <a href={`tel:${form.phone}`} className='text-colour3'>
            {form.phone}
          </a>
        </div>

        {/* Location */}
        <div>
          <strong className='text-xl font-medium'>Location:</strong>{' '}
          {form.location}
        </div>

        {/* Availability */}
        <div>
          <strong className='text-xl font-medium'>Availability 1:</strong>{' '}
          {form.availability1}
        </div>
        <div>
          <strong className='text-xl font-medium'>Availability 2:</strong>{' '}
          {form.availability2}
        </div>
        <div>
          <strong className='text-xl font-medium'>Availability 3:</strong>{' '}
          {form.availability3}
        </div>

        {/* Experience Description */}
        <div>
          <strong className='text-xl font-medium'>
            Experience Description:
          </strong>{' '}
          {form.experienceDescription}
        </div>

        {/* Interests */}
        <div>
          <strong className='text-xl font-medium'>Interests:</strong>{' '}
          {form.interests}
        </div>

        {/* Referral */}
        <div>
          <strong className='text-xl font-medium'>Referral:</strong>{' '}
          {form.referral}
        </div>

        {/* Appointment Type */}
        <div>
          <strong className='text-xl font-medium'>Appointment Type:</strong>{' '}
          {form.appointmentType}
        </div>

        {/* Deposit */}
        <div>
          <strong className='text-xl font-medium'>Deposit:</strong>{' '}
          {form.deposit}
        </div>

        {/* Session Length */}
        <div>
          <strong className='text-xl font-medium'>Session Length:</strong>{' '}
          {form.sessionLength}
        </div>
      </section>
    </article>
  );
}

export default ContactFormItem;
